var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWhiteTelegram = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.4789 3.69164C16.6848 3.60496 16.9103 3.57507 17.1317 3.60507C17.3531 3.63507 17.5624 3.72386 17.7378 3.86221C17.9133 4.00056 18.0484 4.1834 18.1292 4.39171C18.21 4.60001 18.2335 4.82617 18.1973 5.04664L16.3073 16.5108C16.1239 17.6166 14.9106 18.2508 13.8964 17.7C13.0481 17.2391 11.7881 16.5291 10.6548 15.7883C10.0881 15.4175 8.35225 14.23 8.56558 13.385C8.74892 12.6625 11.6656 9.94747 13.3323 8.3333C13.9864 7.69914 13.6881 7.3333 12.9156 7.91664C10.9973 9.36497 7.91725 11.5675 6.89892 12.1875C6.00058 12.7341 5.53225 12.8275 4.97225 12.7341C3.95058 12.5641 3.00308 12.3008 2.22975 11.98C1.18475 11.5466 1.23558 10.11 2.22892 9.69164L16.4789 3.69164Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgWhiteTelegram);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/white-telegram.b7eb182dce6c57eb05dff921a343809e.svg";